import {useAgentModels} from '@github-ui/copilot-shared-ui/agents/use-agent-models'
import {trimModelName} from '../utils/trim-model-name'

export function useSelectedModel(modelId: string | undefined) {
  const {models: agentModels} = useAgentModels()

  if (!modelId || !agentModels) return undefined

  return agentModels.find(m => m.id === trimModelName(modelId))
}
